import { CallMadeOutlined } from '@mui/icons-material';
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
} from '@mui/material';
import {
  UtilityDrawerHookReturnType,
  useUtilityDrawer,
} from 'components/drawers/utility-drawer/utility-drawer.hooks';
import IncFormHelperText from 'components/forms/inc-form-helper-text/inc-form-helper-text.component';
import React, { Ref } from 'react';
import { IncFieldBase } from '../../fields.types';

export type DrawerFieldBaseProps = IncFieldBase<{
  hasValue: (value) => boolean;
  withValue: (
    value,
    drawerProps: UtilityDrawerHookReturnType,
  ) => React.ReactNode;
  withoutValue: (
    value,
    drawerProps: UtilityDrawerHookReturnType,
  ) => React.ReactNode;
  drawer: (drawerProps: UtilityDrawerHookReturnType) => React.ReactNode;
  value: any;
  'data-testid'?: string;
}>;

const DrawerFieldBase = React.forwardRef(
  (
    {
      label,
      error,
      hasValue,
      withValue,
      withoutValue,
      drawer,
      value,
      FormControlProps,
      IncFormHelperTextProps,
      helperText,
      'data-testid': testId = 'DrawerField',
    }: DrawerFieldBaseProps,
    ref: Ref<HTMLButtonElement>,
  ) => {
    const drawerProps = useUtilityDrawer();
    return (
      <>
        <FormControl
          data-testid={testId}
          margin="normal"
          error={!!error}
          {...FormControlProps}
        >
          {label && (
            <FormLabel
              data-testid={`${testId}.FormLabel`}
              id={`${testId}-label`}
            >
              {label}
            </FormLabel>
          )}
          <Box>
            <Button
              onClick={drawerProps.toggle}
              startIcon={<CallMadeOutlined />}
              variant="text"
              data-testid={`${testId}.Button`}
              fullWidth={false}
              aria-labelledby={`${testId}-label`}
              ref={ref}
            >
              {hasValue(value)
                ? withValue(value, drawerProps)
                : withoutValue(value, drawerProps)}
            </Button>
          </Box>
          <FormHelperText>
            <IncFormHelperText
              error={error}
              helperText={helperText}
              {...IncFormHelperTextProps}
            />
          </FormHelperText>
        </FormControl>
        {drawer(drawerProps)}
      </>
    );
  },
);

export default DrawerFieldBase;
